import React from 'react';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import { useThemeContext } from 'contexts/theme';
import { ThemeNames } from 'types/themes';

interface Props {
  isRental: boolean;
  setIsRental: (isRental: boolean) => void;
}

export default function ButtonGroup({ isRental, setIsRental }: Props) {
  const { themeName } = useThemeContext();
  const isZoocasaTheme = themeName === ThemeNames.ZOOCASA;

  return (
    <div className={styles['button-group']}>
      <button onClick={(() => setIsRental(false))} className={buildClassName(!isRental && styles.active, isZoocasaTheme && styles['zoocasa-theme'])}>
        Sold
      </button>
      <button onClick={(() => setIsRental(true))} className={buildClassName(isRental && styles.active, isZoocasaTheme && styles['zoocasa-theme'])}>
        Rented
      </button>
    </div>
  );
}
